module.exports = __webpack_public_path__ + "img/market-banner.fd37ae4e.png";